/**
 * Уведомление «подложка недоступна — переключились на запасную» (задача
 * владельца 24.09.2026, п.2). Свой сигнал, не state.ts (см. extra-basemaps.ts).
 */
import { signal } from '@preact/signals'

/** Метка времени последнего показа; null — тост скрыт. */
export const basemapFallbackNotice = signal<number | null>(null)

export function announceBasemapFallback(): void {
  basemapFallbackNotice.value = Date.now()
}

export function dismissBasemapFallbackNotice(): void {
  basemapFallbackNotice.value = null
}
